import React from "react";
import {LuZoomIn} from "react-icons/lu";
import {BsFiletypeDocx} from "react-icons/bs";
import {AiOutlineMail} from "react-icons/ai";

const PdfThumbnail = ({searchParams, splitterData, extensionType, setHighlightedIndices, fileUrl, pdfImages}) => {
    const documentIdPath = searchParams.get("document_id");
    const splitIdPath = parseInt(searchParams.get("split_id"));

    const pageNumber = splitterData[documentIdPath]?.[splitIdPath]?.traddocs_watermark_indices?.[0];

    return (
        <div className="w-28 h-28 bg-gray-200 rounded flex justify-center items-center relative overflow-hidden">
            {["pdf", "jpg", "jpeg", "png"].includes(extensionType) && (
                <button
                    onClick={() => setHighlightedIndices([0])}
                    className="group absolute w-full h-full bg-black opacity-10 hover:opacity-40 transition z-20 flex items-center justify-center"
                >
                    <LuZoomIn className="text-white w-12 h-12 group-hover:flex hidden"/>
                </button>
            )}
            <div className="flex justify-center items-center">
                {extensionType === "docx" ? (
                    <div className="flex items-center w-full px-3 flex-col">
                        <BsFiletypeDocx className="text-gray-400 w-8 h-8"/>
                    </div>) : extensionType === "pdf" ? pdfImages && (
                    <img src={pdfImages[pageNumber - 1]} alt={''}/>
                ) : ['jpg', 'jpeg', 'png'].includes(extensionType) ? (
                    <img src={fileUrl} alt={''}/>) : ["msg", "eml"].includes(extensionType) ?
                    <div className="flex items-center w-full px-3 flex-col">
                        <AiOutlineMail className="text-gray-400 w-8 h-8"/>
                    </div> : <></>}
            </div>
        </div>
    );
};

export default PdfThumbnail;
